/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_RevokedInputs */

const en_us2_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission withdrawn and photos deleted.`)
};

const pt_br2_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorização revogada e fotos apagadas.`)
};

const es_419_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permiso retirado y fotos borradas.`)
};

const pt_pt2_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorização revogada e fotos apagadas.`)
};

const fr_fr2_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisation retirée et photos supprimées.`)
};

const de_de2_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlaubnis widerrufen und Fotos gelöscht.`)
};

const it_it2_body_assessment_consent_revoked = /** @type {(inputs: Body_Assessment_Consent_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenso revocato e foto eliminate.`)
};

/**
* | output |
* | --- |
* | "Permission withdrawn and photos deleted." |
*
* @param {Body_Assessment_Consent_RevokedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_revoked = /** @type {((inputs?: Body_Assessment_Consent_RevokedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_RevokedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_revoked(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_revoked(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_revoked(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_revoked(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_revoked(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_revoked(inputs)
	return en_us2_body_assessment_consent_revoked(inputs)
});
export { body_assessment_consent_revoked as "body-assessment.consent_revoked" }